export type TTags = "top" | "new" | "show" | "ask" | "job";
export const stories: Record<TTags, string> = {
  ask: "ask",
  job: "jobs",
  new: "newest",
  show: "show",
  top: "news",
};